export default __webpack_public_path__ + "static/media/bed.51be9722.png";